var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a;
import { jsx, jsxs } from "react/jsx-runtime";
import React__default, { Component } from "react";
import PropTypes from "prop-types";
import _toPairs from "lodash/toPairs";
import { withTheme } from "styled-components";
import { TooltipPopper, TriggerText, Tooltip, Heading, Paragraph } from "@zillow/constellation";
import withDimensions from "./withDimensions.esm.js";
import PropInterpolatorWrapper from "./Chart/common/PropInterpolator.esm.js";
import DonutChart from "./DonutChart.esm.js";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
const MonthlyPITooltip = /* @__PURE__ */ jsx(TooltipPopper, { generateDescribedBy: false, triggered: /* @__PURE__ */ jsx(Tooltip, { role: "tooltip", "aria-describedby": null, body: /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
  /* @__PURE__ */ jsx(Heading, { level: "4", children: "Principal and Interest" }),
  /* @__PURE__ */ jsx(Paragraph, { children: "Your mortgage principal is the total amount you've borrowed from a lender to buy a home. Interest is the fee lenders charge you for borrowing their money; usually, an annual percentage rate." })
] }) }), children: /* @__PURE__ */ jsx(TriggerText, { as: "text", role: "button", tabIndex: "0", "aria-haspopup": "false", children: "P & I" }) });
const PaymentDonutChart = withTheme((_a = class extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "colors", (i) => [this.props.theme.constellation.colors.blue400, this.props.theme.constellation.colors.blue500, this.props.theme.constellation.colors.blue600, this.props.theme.constellation.colors.blue300, this.props.theme.constellation.colors.blue200][i] || this.props.theme.constellation.colors.black);
  }
  render() {
    const nameMap = {
      monthlyPI: MonthlyPITooltip,
      monthlyPropertyTax: "Taxes",
      monthlyHomeownersInsurance: "Insurance",
      monthlyPMI: "PMI",
      monthlyHOA: "HOA",
      monthlyMIP: this.props.monthlyMIP ? "MIP" : ""
    };
    const usedColorsList = [];
    const getColors = (i) => usedColorsList[i] || this.props.theme.constellation.colors.black;
    const chartData = _toPairs(this.props).filter((item) => !!nameMap[item[0]]).map((item) => ({
      label: nameMap[item[0]],
      value: Math.round(item[1])
    })).filter((element, i) => {
      if (element.value > 0) {
        usedColorsList.push(this.colors(i));
        return true;
      }
      return false;
    });
    let constrainedDimension = 140;
    let radiusRatio = 2.25;
    let height = 140;
    if (!this.props.hideLabels) {
      constrainedDimension = Math.min(this.props.containerWidth, 275) - 30;
      radiusRatio = 3;
      height = 275;
    }
    return /* @__PURE__ */ jsx("div", { style: {
      height
    }, children: /* @__PURE__ */ jsx(DonutChart, { data: chartData, width: this.props.containerWidth, height, radius: constrainedDimension / radiusRatio, innerRadius: constrainedDimension / radiusRatio * 0.87, valueFormatter: getWholeDollars, centerText: "Your payment", colors: getColors, hideLabels: this.props.hideLabels, smallCenterLabel: this.props.smallCenterLabel, centerValue: Math.round(this.props.monthlyPayment) }) });
  }
}, __publicField(_a, "propTypes", {
  monthlyPayment: PropTypes.number,
  containerWidth: PropTypes.number,
  hideLabels: PropTypes.bool,
  smallCenterLabel: PropTypes.bool,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  theme: PropTypes.object
}), _a));
const PaymentDonutChart$1 = PropInterpolatorWrapper(withDimensions(PaymentDonutChart, {
  defaultHeight: 275,
  defaultWidth: 347
}));
export {
  PaymentDonutChart$1 as default
};
